/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Dialog_Text_To_Audio_Too_LongInputs */

const en_dialog_text_to_audio_too_long = /** @type {(inputs: Dialog_Text_To_Audio_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Text is too long. Maximum length is ${i?.max} characters.`)
};

const es_dialog_text_to_audio_too_long = /** @type {(inputs: Dialog_Text_To_Audio_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El texto es demasiado largo. La longitud máxima es de ${i?.max} caracteres.`)
};

/**
* | output |
* | --- |
* | "Text is too long. Maximum length is {max} characters." |
*
* @param {Dialog_Text_To_Audio_Too_LongInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_too_long = /** @type {((inputs: Dialog_Text_To_Audio_Too_LongInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Too_LongInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_too_long(inputs)
	return en_dialog_text_to_audio_too_long(inputs)
});